import { useEffect, useState } from "react";
import { ImportExportOutlined } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { IPDCLineChart, WideChartContainer,IPDCBarChart } from "../../../../../components/Charts";

import { GetDataFromApiWithParams } from "../../../../../services/api/ExecuteApiRequests";

export default function PBRequestVsResponseParkCard({ parkId = null }) {
  const [referredResponses, setReferredResponses] = useState([]);

  useEffect(() => {
    const fetchBPRequestVsResponse = async () => {
      try {
        const referredRes = await GetDataFromApiWithParams('buildingPermits/bpperpark');
        console.log("happpppppppy", referredRes)
        console.log(referredRes);
        setReferredResponses(referredRes || []);
      } catch (e) {
        console.error(e);
      }
    };
    fetchBPRequestVsResponse();
  }, [parkId]);

  return (
    <Link to="/listBPermit">
      {referredResponses && referredResponses?.length > 0 ? (
        <WideChartContainer
          THECHART={
            <IPDCBarChart
              data={referredResponses}
              xDataKeys="name"
              yDataKeys={["permit_count"]}
              showButton={false}
            />
          }
          title="Building Permit Per Park"
          link="/listBPermitPark"
          showMoreButton={false}
          avatar={<ImportExportOutlined />}
        />
      ) : (
        <WideChartContainer
          THECHART={
            <IPDCBarChart
              data={referredResponses}
              xDataKeys="Park"
              yDataKeys={["request", "response"]}
              showButton={false}
            />
          }
          title="Occupancy Permit per Park"
          link="/listOPermitPark"
          showMoreButton={false}
          avatar={<ImportExportOutlined />}
        />
      )}
    </Link>
  );
}
